export interface SkeletonProps {
  className?: string
  /** Accessible label for the shimmer region (screen readers). */
  label?: string
}

/** Content placeholder. Decorative by default; pass a label when stand-alone. */
export function Skeleton({ className = '', label }: SkeletonProps) {
  return (
    <div
      className={`motion-safe:animate-pulse rounded-xl bg-ground-3 ${className}`}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  )
}

export function SkeletonList({ rows = 3, label = 'Loading content' }: { rows?: number; label?: string }) {
  return (
    <div className="flex flex-col gap-3" role="status" aria-label={label}>
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} className="h-[72px] w-full" />
      ))}
      <span className="sr-only">{label}</span>
    </div>
  )
}
